// @ts-nocheck

import {
  selectBasketItems,
  selectBasketMode,
  selectBasketSelectedBonusId,
  selectBasketSelectedFreebetId,
} from '../../selectors/basket/basketPrimary.selector';
import { selectBasketShowResume, selectBasketIsInputDisabled } from '../../selectors/basketCommon.selector';
import { selectBasketEnhancedItems } from '../../selectors/basketItems.selector';
import { selectUserFreebetBankroll } from '../../selectors/user/userPrimary.selector';
import { BasketModes } from '../../types/basket';
import { createShallowEqualSelector } from '../../utils/reselect';

const getItemIdFromProps = (_, { itemId }: { itemId?: number }) => itemId;

const makeBasketFreebetsSwitchPropsSelector = () =>
  createShallowEqualSelector(
    [
      selectBasketMode,
      selectUserFreebetBankroll,
      selectBasketEnhancedItems,
      selectBasketShowResume,
      selectBasketSelectedFreebetId,
      selectBasketSelectedBonusId,
      getItemIdFromProps,
      selectBasketItems,
      selectBasketIsInputDisabled,
    ],
    (
      mode,
      userFreebetBankroll,
      items,
      showResume,
      basketSelectedFreebetId,
      basketSelectedBonusId,
      itemIdModeSimple,
      basketItems,
      isDisabled,
    ) => {
      const isModeSimple = mode === BasketModes.SIMPLE;
      const isOneSimpleBet = isModeSimple && items.length === 1;
      const isMultipleSimpleBets = isModeSimple && items.length > 1;

      let itemId = null;
      let isSelected = false;
      let isVisible =
        userFreebetBankroll > 0 &&
        !showResume &&
        ((isOneSimpleBet && !itemIdModeSimple) ||
          (!isModeSimple && !itemIdModeSimple) ||
          (isMultipleSimpleBets && itemIdModeSimple));

      let isFreebetIsSelected = false;
      if (isOneSimpleBet && !itemIdModeSimple) {
        itemId = items[0].oddId;
        isSelected = typeof items[0].selectedFreebetId === 'boolean' ? items[0].selectedFreebetId : false;
        isFreebetIsSelected = !!items[0].selectedBonusId;
      } else if (isMultipleSimpleBets && itemIdModeSimple) {
        itemId = itemIdModeSimple;
        const item = basketItems[itemId];
        isSelected = typeof item?.selectedFreebetId === 'boolean' ? item?.selectedFreebetId : false;
        isFreebetIsSelected = !!item?.selectedBonusId;
      } else {
        isSelected = basketSelectedFreebetId;
        isFreebetIsSelected = !!basketSelectedBonusId;
      }

      if (isVisible) {
        isVisible = !isFreebetIsSelected;
      }

      return {
        isVisible,
        itemId,
        isSelected,
        isDisabled,
      };
    },
  );

export default makeBasketFreebetsSwitchPropsSelector;
